var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('helio-field',{staticClass:"table__search",attrs:{"placeholder":_vm.placeholder,"large":true,"icon":"search","icon-weight":"light"},on:{"changed":_vm.debounceTermChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }